import { render, staticRenderFns } from "./manufacturers.vue?vue&type=template&id=3fb8d880&"
import script from "./manufacturers.vue?vue&type=script&lang=js&"
export * from "./manufacturers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kinglinux/.baobaobot/teams/白/workspace_3GTAPP/projects/ita.GroupTravel.Website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fb8d880')) {
      api.createRecord('3fb8d880', component.options)
    } else {
      api.reload('3fb8d880', component.options)
    }
    module.hot.accept("./manufacturers.vue?vue&type=template&id=3fb8d880&", function () {
      api.rerender('3fb8d880', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/itaSetting/manufacturers.vue"
export default component.exports